module.exports = __webpack_public_path__ + "static/media/sc4.848f9a07.mp4";